module.exports = __webpack_public_path__ + "img/138.b9bfd874.jpg";